import {
  ROW,
  TEXTBOX,
  VERTICALSPACER,
  STANDARDPRODUCTTABLE,
  ABOUT,
  APPROW,
  AUDIOEMBED,
  AWARDSBADGEDROPDOWN,
  AWARDSHERO,
  AWARDSNAVIGATION,
  AWARDTABLE,
  BOXSPLASH,
  BOXTABLE,
  BRANDHEADER,
  BULLETEDLIST,
  C3CHART,
  CALCULATOR,
  CARDTEMPLATE,
  CATEGORYTILES,
  CDSPRODUCTTABLE,
  CDSFILTERS,
  CENTEREDHERO,
  CHARTSECTION,
  COLLAPSIBLEPARAGRAPH,
  COUNTDOWNBOX,
  CREDITCARDTABLE,
  CTABOX,
  DISCLOSURE,
  DIVIDER,
  EDITABLEBULLETEDLIST,
  EDITABLEINTERESTCALCULATOR,
  EDITABLELOGOSALAD,
  EDITABLEPANELGROUP,
  EDITABLEPRODUCTTABLE,
  EDITABLETHREETILES,
  EDITORCONTROL,
  EXPANDINGPRODUCTTABLE,
  FEATUREBAR,
  FEATUREDSTORY,
  GIGYASETUP,
  GLOBALFOOTERMASK,
  GLOBALNAV,
  GRIDFORM,
  ICONHEADER,
  IMAGE,
  IMAGECONTENT,
  LABELEDC3CHART,
  LASTCHANCE,
  LASTUPDATE,
  LENDERCARD,
  MARKETPLACEPRODUCTCARD,
  NPSCRMEMAIL,
  PAGE,
  PARAGRAPH,
  PASSWORDLOCK,
  PROSCONSPRODUCTTABLE,
  QUERYFILTERS,
  QUERYPARAMMANAGER,
  QUERYPARAMSECTION,
  ROWTWOCOL,
  ROWTWOCOLOLD,
  SCREENSIZECONDITIONAL,
  SCROLLCONTROL,
  SPLASH,
  STANDARDHERO,
  STORY,
  STORYBLOCK,
  STORYCARDS,
  TERMSTABLE,
  THREESTEPS,
  THREESTEPS2,
  TILECAROUSEL,
  UNIVERSALPRODUCTTABLE,
  VIDEOEMBED,
  ZIGZAG,
} from './types';
import { NW_COMPONENTS } from './utils';

import PageComponent from '../../components/page/page';
import RowComponent from '../../components/row/row';
import TextBoxComponent from '../../components/text-box/text-box';
import VerticalSpacerComponent from '../../components/vertical-spacer/vertical-spacer';

/**
 * Component name associations on landing page client components.
 */
const LPC_COMPONENTS = {
  [ROW]: () => RowComponent,
  [TEXTBOX]: () => TextBoxComponent,
  [VERTICALSPACER]: () => VerticalSpacerComponent,
  [PAGE]: () => PageComponent,
  [STANDARDPRODUCTTABLE]: () => [import('@nerdwallet/react-product-table')],
  [ABOUT]: () => [import('../../components/about/about')],
  [APPROW]: () => [import('../../components/app-row/app-row')],
  [AUDIOEMBED]: () => [import('../../components/audio-embed/audio-embed')],
  [AWARDSBADGEDROPDOWN]: () => [
    import('../../components/awards-badge-dropdown/awards-badge-dropdown'),
  ],
  [AWARDSHERO]: () => [import('../../components/awards-hero/awards-hero')],
  [AWARDSNAVIGATION]: () => [
    import('../../components/awards-navigation/awards-navigation'),
  ],
  [AWARDTABLE]: () => [import('../../components/award-table/award-table')],
  [BOXSPLASH]: () => [import('../../components/box-splash/box-splash')],
  [BOXTABLE]: () => [import('../../components/box-table/box-table')],
  [BRANDHEADER]: () => [import('../../components/brand-header/brand-header')],
  [BULLETEDLIST]: () => [
    import('../../components/bulleted-list/bulleted-list'),
  ],
  [C3CHART]: () => [import('../../components/c3-chart/c3-chart')],
  [CALCULATOR]: () => [import('../../components/calculator/calculator')],
  [CARDTEMPLATE]: () => [
    import('../../components/card-template/card-template'),
  ],
  [CATEGORYTILES]: () => [
    import('../../components/category-tiles/category-tiles.jsx'),
  ],
  [CDSPRODUCTTABLE]: () => [
    import('../../components/cds-product-table/cds-product-table'),
  ],
  [CDSFILTERS]: () => [import('../../components/cds-filters/cds-filters')],
  [CENTEREDHERO]: () => [
    import('../../components/centered-hero/centered-hero'),
  ],
  [CHARTSECTION]: () => [
    import('../../components/chart-section/chart-section'),
  ],
  [COLLAPSIBLEPARAGRAPH]: () => [
    import('../../components/collapsible-paragraph/collapsible-paragraph'),
  ],
  [COUNTDOWNBOX]: () => [
    import('../../components/countdown-box/countdown-box'),
  ],
  [CREDITCARDTABLE]: () => [
    import('../../components/credit-card-table/credit-card-table'),
  ],
  [CTABOX]: () => [import('../../components/cta-box/cta-box')],
  [DISCLOSURE]: () => [import('../../components/disclosure/disclosure')],
  [DIVIDER]: () => [import('../../components/divider/divider')],
  [EDITABLEBULLETEDLIST]: () => [
    import('../../components/editable-bulleted-list/editable-bulleted-list'),
  ],
  [EDITABLEINTERESTCALCULATOR]: () => [
    import(
      '../../components/editable-interest-calculator/editable-interest-calculator'
    ),
  ],
  [EDITABLELOGOSALAD]: () => [
    import('../../components/logo-salad/editable-logo-salad'),
  ],
  [EDITABLEPANELGROUP]: () => [
    import('../../components/editable-panel-group/editable-panel-group'),
  ],
  [EDITABLEPRODUCTTABLE]: () => [
    import('../../components/editable-product-table/editable-product-table'),
  ],
  [EDITABLETHREETILES]: () => [
    import('../../components/editable-three-tiles/editable-three-tiles'),
  ],
  [EDITORCONTROL]: () => [
    import('../../containers/editor-control/editor-control'),
  ],
  [EXPANDINGPRODUCTTABLE]: () => [
    import('../../components/expanding-product-table/expanding-product-table'),
  ],
  [FEATUREBAR]: () => [import('../../components/feature-bar/feature-bar')],
  [FEATUREDSTORY]: () => [
    import('../../components/featured-story/featured-story'),
  ],
  [GIGYASETUP]: () => [import('../../components/gigya-setup/gigya-setup')],
  [GLOBALFOOTERMASK]: () => [
    import('../../components/global-footer-mask/global-footer-mask'),
  ],
  [GLOBALNAV]: () => [import('../../components/global-nav/global-nav')],
  [GRIDFORM]: () => [import('../../components/grid-form/grid-form')],
  [ICONHEADER]: () => [import('../../components/icon-header/icon-header')],
  [IMAGE]: () => [import('../../components/image/image')],
  [IMAGECONTENT]: () => [
    import('../../components/image-content/image-content'),
  ],
  [LABELEDC3CHART]: () => [
    import('../../components/labeled-c3-chart/labeled-c3-chart'),
  ],
  [LASTCHANCE]: () => [import('../../components/last-chance/last-chance')],
  [LASTUPDATE]: () => [import('../../components/last-update/last-update')],
  [LENDERCARD]: () => [import('../../components/lender-card/lender-card')],
  [MARKETPLACEPRODUCTCARD]: () => [
    import(
      '../../components/marketplace-product-card/marketplace-product-card'
    ),
  ],
  [NPSCRMEMAIL]: () => [import('../../components/nps-crm-email/nps-crm-email')],
  [PARAGRAPH]: () => [import('../../components/paragraph/paragraph')],
  [PASSWORDLOCK]: () => [
    import('../../components/navigate-toggle/password-lock/password-lock'),
  ],
  [PROSCONSPRODUCTTABLE]: () => [
    import('../../components/pros-cons-product-table/pros-cons-product-table'),
  ],
  [QUERYFILTERS]: () => [
    import('../../components/query-filters/query-filters'),
  ],
  [QUERYPARAMMANAGER]: () => [
    import('../../containers/query-param-manager/query-param-manager'),
  ],
  [QUERYPARAMSECTION]: () => [
    import('../../containers/query-param-section/query-param-section'),
  ],
  [ROWTWOCOL]: () => [import('../../components/row-two-col/row-two-col')],
  [ROWTWOCOLOLD]: () => [
    import('../../components/row-two-col-old/row-two-col-old'),
  ],
  [SCREENSIZECONDITIONAL]: () => [
    import('../../containers/screen-size-conditional/screen-size-conditional'),
  ],
  [SCROLLCONTROL]: () => [
    import('../../components/scroll-control/scroll-control'),
  ],
  [SPLASH]: () => [import('../../components/splash/splash')],
  [STANDARDHERO]: () => [
    import('../../components/standard-hero/standard-hero'),
  ],
  [STORY]: () => [import('../../containers/story/story')],
  [STORYBLOCK]: () => [import('../../components/story-block/story-block')],
  [STORYCARDS]: () => [import('../../components/story-cards/story-cards')],
  [TERMSTABLE]: () => [import('../../components/terms-table/terms-table')],
  [THREESTEPS]: () => [import('../../components/three-steps/three-steps')],
  [THREESTEPS2]: () => [import('../../components/three-steps-2/three-steps-2')],
  [TILECAROUSEL]: () => [
    import('../../components/tile-carousel/tile-carousel'),
  ],
  [UNIVERSALPRODUCTTABLE]: () => [
    import('../../components/universal-product-table/universal-product-table'),
  ],
  [VIDEOEMBED]: () => [import('../../components/video-embed/video-embed')],
  [ZIGZAG]: () => [import('../../components/zig-zag/zig-zag')],
};

/**
 * Include default Structured Content component names so we can interpret documents that contain generic NW components.
 */
export default {
  ...NW_COMPONENTS,
  ...LPC_COMPONENTS,
};
